export function getUrl() {
  if (process.env.NODE_ENV === 'production') {
    return `${window.location.origin}/api/`;
  }

  return 'http://localhost:8000/api/';
  // return process.env.REACT_APP_API_URL;
}
